const TIPO_PDF = 'application/pdf'

const isPdf = (arquivo) => arquivo.type === TIPO_PDF || /\.pdf$/i.test(arquivo.name || '')

const carregarPdfjs = async () => {
    const pdfjs = await import('pdfjs-dist/legacy/build/pdf')
    await import('pdfjs-dist/legacy/build/pdf.worker.entry')
    return pdfjs
}

/**
 * Indica se o PDF exige senha para ser aberto.
 * PDFs com apenas restrições de permissão (impressão, cópia, edição) abrem sem senha e não são considerados protegidos.
 * Arquivos que não puderem ser analisados são aceitos, ficando a validação final a cargo do backend.
 */
export const pdfPossuiSenha = async (arquivo) => {
    if (!isPdf(arquivo)) {
        return false
    }

    let tarefa = null
    try {
        const pdfjs = await carregarPdfjs()
        tarefa = pdfjs.getDocument({data: new Uint8Array(await arquivo.arrayBuffer())})
        await tarefa.promise
        return false
    } catch (e) {
        return e.name === 'PasswordException'
    } finally {
        if (tarefa) {
            await tarefa.destroy()
        }
    }
}
